import React from 'react'
import GroupLinks from './GroupLinks'
import GroupLinksMobile from './GroupLinksMobile'
import FooterSocial from './FooterSocial'
import Stamps from './Stamps'

const FooterLinks = () => {
  return (
    <>
      <GroupLinks />
      <GroupLinksMobile />
      <Stamps />
      <FooterSocial />
    </>
  )
}

export default FooterLinks
